(() => {
  if (document.getElementById('ph-floating-preview') || new URLSearchParams(location.search).has('ph_cart_edit')) return;
  const bar = document.createElement('div');
  bar.id = 'ph-floating-preview';
  bar.className = 'ph-floating-preview';
  bar.setAttribute('aria-hidden', 'true');
  bar.inert = true;
  bar.innerHTML = '<button type="button" aria-label="Preview your personalized design"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.8"/></svg><span>Preview</span></button>';
  document.body.append(bar);
  const button = bar.querySelector('button');
  let queued = false, shown = false, modalObserver, observedModal;
  let validationTimer;
  const visible = el => !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  function show(next) {
    if (next === shown) return;
    shown = next;
    bar.classList.toggle('is-visible', next);
    bar.setAttribute('aria-hidden', String(!next));
    bar.inert = !next;
  }
  function update() {
    queued = false;
    const original = document.getElementById('customily-preview-button');
    const modal = document.querySelector('.customily-modal-preview-only');
    const modalOpen = visible(modal);
    if (modal && modal !== observedModal) {
      modalObserver?.disconnect();
      observedModal = modal;
      modalObserver = new MutationObserver(schedule);
      modalObserver.observe(modal, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    }
    if (innerWidth >= 768 || !visible(original) || modalOpen || document.querySelector('dialog[open]') || document.body.classList.contains('ph-editor-open')) {
      show(false); return;
    }
    const rect = original.getBoundingClientRect();
    const gallery = document.querySelector('.t4s-product__media-wrapper');
    const galleryPassed = !gallery || gallery.getBoundingClientRect().bottom < 80;
    const originalOnScreen = rect.bottom > 0 && rect.top < innerHeight;
    const deepEnough = scrollY > innerHeight * .8 && (galleryPassed || rect.bottom < 0);
    let bottom = 0;
    for (const el of document.querySelectorAll('#PBarNextFrameWrapper,.t4s-sticky-atc,.t4s-toolbar')) {
      if (!visible(el)) continue;
      const r = el.getBoundingClientRect();
      if (getComputedStyle(el).position === 'fixed' && r.top > innerHeight / 2 && r.top < innerHeight && r.bottom >= innerHeight - 3) bottom = Math.max(bottom, innerHeight - r.top);
    }
    bar.style.setProperty('--ph-preview-bottom', Math.ceil(bottom) + 'px');
    button.disabled = original.disabled;
    show(deepEnough && !originalOnScreen);
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }
  button.addEventListener('click', () => {
    const original = document.getElementById('customily-preview-button');
    if (!original || original.disabled) return;
    original.click();
    schedule();
  });
  document.addEventListener('click', event => {
    if (!event.target.closest?.('#customily-preview-button')) return;
    clearTimeout(validationTimer);
  }, true);
  window.addEventListener('customily-required-error', () => {
    clearTimeout(validationTimer);
    validationTimer = setTimeout(() => {
      const options = document.getElementById('customily-options');
      if (!options || visible(document.querySelector('.customily-modal-preview-only'))) return;
      const error = Array.from(options.querySelectorAll('.customily-required-label > span,[aria-invalid="true"]')).find(visible);
      if (!error) return;
      const errorTarget = error.closest('.customily_option') || error;
      const label = errorTarget.querySelector('label') || errorTarget;
      const header = document.querySelector('.t4s-section-header');
      const inset = Math.min(200, header?.getBoundingClientRect().height || 64) + 24;
      const hadTabindex = errorTarget.hasAttribute('tabindex');
      if (!hadTabindex) {
        const target = errorTarget;
        target.setAttribute('tabindex', '-1');
        target.addEventListener('blur', () => target.removeAttribute('tabindex'), {once:true});
      }
      errorTarget.focus({preventScroll:true});
      window.scrollTo({top:Math.max(0, scrollY + label.getBoundingClientRect().top - inset),behavior:'instant'});
      schedule();
    }, 120);
  });
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule);
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  document.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  const resize = new ResizeObserver(schedule);
  resize.observe(document.getElementById('MainContent') || document.body);
  schedule();
})();
